module.exports = __webpack_public_path__ + "static/media/help-support-banner.83b1e817.jpg";